import * as React from "react";
import { Facebook, Instagram, Linkedin, Mail, MapPin, Phone, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
const services = [{
  label: "DFY (Done For You) SaaS Setup",
  href: "#"
}, {
  label: "DWY (Done With You) SaaS Support",
  href: "#"
}, {
  label: "DIY (Do It Yourself) SaaS Model Training",
  href: "#"
}];
const legalLinks = [{
  label: "Privacy Policy",
  href: "https://sub1.agssuite.com/privacy-policy-5951-9870"
}, {
  label: "Terms & Conditions",
  href: "https://sub1.agssuite.com/terms-conditions-7977-7957"
}, {
  label: "",
  href: "#"
}, {
  label: "",
  href: "#"
}];
const socialLinks = [{
  label: "LinkedIn",
  icon: Linkedin,
  href: "#"
}, {
  label: "Twitter",
  icon: Twitter,
  href: "#"
}, {
  label: "Facebook",
  icon: Facebook,
  href: "#"
}, {
  label: "Instagram",
  icon: Instagram,
  href: "#"
}];
export default function Footer() {
  React.useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://widgets.leadconnectorhq.com/loader.js";
    script.setAttribute("data-resources-url", "https://widgets.leadconnectorhq.com/chat-widget/loader.js");
    script.setAttribute("data-widget-id", "69de1504e703e3605ec7f9da");
    script.setAttribute("data-business-name", "{business_name}");
    script.async = true;
    document.body.appendChild(script);
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);
  return <section id="footer" className="dark bg-background text-foreground">
      <div className="bg-card w-full pt-16 pb-8">
        <div className="container mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4 mb-12">
            
            <div className="space-y-6">
              <Link to="/">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1623996/img/ags_partners_logo_monochrome.png" alt={`${"{business_name}"} Logo`} className="h-10 w-auto opacity-80 hover:opacity-100 transition-opacity" />
              </Link>
              <ul className="space-y-4 text-sm text-muted-foreground">
                <li className="flex items-start gap-3">
                  <MapPin className="size-4 shrink-0 mt-0.5 text-secondary" />
                  <span>1309 Coffeen Avenue <br />STE 19317<br />Sheridan, WY82801</span>
                </li>
                <li className="flex items-center gap-3">
                  <Phone className="size-4 shrink-0 text-secondary" />
                  <span>469-546-5998</span>
                </li>
                <li className="flex items-center gap-3">
                  <Mail className="size-4 shrink-0 text-secondary" />
                  <span>support@agssuite.com</span>
                </li>
              </ul>
            </div>

            <div className="space-y-6">
              <h4 className="text-lg font-semibold font-default text-foreground">Services</h4>
              <ul className="space-y-3 text-sm text-muted-foreground">
                {services.map((service, i) => <li key={i} data-index={i}>
                    <Link to={service.href} className="hover:text-secondary transition-colors">
                      {service.label}
                    </Link>
                  </li>)}
              </ul>
            </div>

            <div className="space-y-6">
              <h4 className="text-lg font-semibold font-default text-foreground">Legal Links</h4>
              <ul className="space-y-3 text-sm text-muted-foreground">
                {legalLinks.map((link, i) => <li key={i} data-index={i}>
                    <Link to={link.href} className="hover:text-secondary transition-colors">
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
            </div>

            <div className="space-y-6">
              <h4 className="text-lg font-semibold font-default text-foreground">Social Connect</h4>
              <p className="text-sm text-muted-foreground">AI automation, expert consulting, and high-performance SaaS models designed for rapid growth</p>
              <div className="flex items-center gap-4">
                {socialLinks.map((social, i) => {
                const Icon = social.icon;
                return <Link key={i} data-index={i} to={social.href} className="text-muted-foreground hover:text-secondary transition-all duration-300 hover:drop-shadow-[0_0_8px_var(--color-secondary)]" aria-label={social.label}>
                      <Icon className="size-5" />
                    </Link>;
              })}
              </div>
            </div>

          </div>

          <Separator className="bg-muted-foreground/20 mb-6" />

          <div className="flex flex-col md:flex-row items-center justify-center text-center md:text-left text-xs text-muted-foreground">
            <p>AGS Partners is a wholly owned dba of Executive Sovereign Ventures LLC. © 2026 All Rights Reserved.</p>
          </div>
        </div>
      </div>
    </section>;
}